import { Avatar, Col, message, Modal, Row, Space } from 'antd';
import { Alert } from "components/elements";
import { useCallback, useEffect, useMemo, useState, } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { deleteKeysByList, generateRandomString } from "utils/helper";
import * as services from "../services/employeeApi";
import { setEmpRemainingLeave, setGetLeaveBenefit, setIsLoading, setLeaveBenefitList } from "../slices/employeeSlice";


function useEmployeeWorkInLeaveBenefit() {
  const [pagination, setPagination] = useState({ page: 1, size: 10 });
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const dispatch = useDispatch();
  const leaveBenefitList = useSelector((state) => state.employee.leaveBenefitList);
  const currentEmployee = useSelector((state) => state.company.currentEmployee);

  const { remainingLeave, employeeWorkInCount } = useSelector((state) => state.employee);
  const isLoading = useSelector((state) => state.employee.isLoading);
  const [leaveGroupOptions, setLeaveGroupOptions] = useState([]);
  const [lang, setLang] = useState("en");
  const { t, i18n } = useTranslation();


  const getLeaveBenefit = useSelector((state) => state.employee.getLeaveBenefit);
  const [currentMyRequest, setCurrentMyRequest] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const DELETE_KEYS_LIST = ["current", "pageSize", "pagination"];
  const [sorter, setSorter] = useState([]);
  const [selectedYear, setYear] = useState(new Date().getFullYear() + "");
  const { id } = useParams();
  // const toInitialValues = (initialValues = {}) => {
  //   const {
  //     createDate,
  //     updateDate,
  //     employeeDetails: { name, nameEn, surname, surnameEn, employeeImage },
  //     positionDetail: { positionName, positionNameEn },
  //     leaveTypeDetails
  //   } = initialValues;

  //   const modifiedValues = {
  //     createDate,
  //     updateDate,
  //     name,
  //     nameEn,
  //     surname,
  //     surnameEn,
  //     employeeImage,
  //     positionName,
  //     positionNameEn,
  //     leaveTypeDetails: leaveTypeDetails.map(leaveType => ({
  //       ...leaveType,
  //       remainingLeaveId: leaveType.remainingLeaveId,
  //       leaveTypeName: leaveType.leaveTypeName,
  //       leaveTypeNameEn: leaveType.leaveTypeNameEn,
  //       totalLeaveDays: leaveType.totalLeaveDays,
  //       totalLeaveHours: leaveType.totalLeaveHours
  //     }))
  //   };

  //   return modifiedValues;
  // };
  const onCalculate = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));

      await services.calNewLeaveBenefit({
        companyId: currentCompany,
        employeeId: id,
        year: selectedYear,
      });

      await getEmployLeaveBenefitList({
        page: 0,
        size: 10,
      });
    } catch (error) {
      console.error('Error calculating leave benefit:', error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [dispatch, currentCompany, id, selectedYear]);


  // onCancelCustom = useCallback((record) => {
  //   cancelCustomLeaveBenefit(record)
  // })


  const onEdit = async (record) => {
    const values = {
      leaveBenefitId: record.remainingLeaveId,
      requestId: generateRandomString(),
      companyId: currentCompany,
      employeeId: id,
      actionId: currentEmployee
    };
    // setModalType(MODAL_TYPE.EDIT);
    let editingData = await services.getEmployeeLeaveBenefit(values);
    setCurrentMyRequest(editingData?.data);
    setIsModalOpen(true);
  };

  const getInfo = useMemo(
    () => {
      let language = i18n.language == "en" ? "En" : "";

      // const leaveTypes = leaveTypeDetails.map(leave => ({
      //   remainingLeaveId: leave.remainingLeaveId,
      //   leaveTypeName: leave["leaveTypeName" + language] ?? leave.leaveTypeName,
      //   totalLeaveDays: leave.totalLeaveDays,
      //   totalLeaveHours: leave.totalLeaveHours
      // }));
      return {
        // employeeImage: getLeaveBenefit?.employeeImage,
        // positionName: getLeaveBenefit?.employeeDetails.positionDetail?.["positionName" + language] ?? "",
        // name: getLeaveBenefit.employeeDetails?.["name" + language] ?? "",
        // surName: getLeaveBenefit.employeeDetails?.["surname" + language] ?? "",
        // createDate: getLeaveBenefit?.createDate,
        // updateDate: getLeaveBenefit?.updateDate,
        // leaveTypes: leaveTypes

      }
    },
    [getLeaveBenefit, i18n.language],
  )

  function createImageUrl(base64Data, contentType) {
    return `data:${contentType};base64,${base64Data}`;
  }


  const userAvatar = useCallback(
    () => {
      if (getInfo.employeeImage) {
        const imageUrl = createImageUrl(getInfo.employeeImage, "image/png");
        return imageUrl;
      } else {
        return null
      }
    },
    [getInfo.employeeImage],
  )


  function toParams(values = {}) {
    const { pagination = {}, sortBy = [] } = values;
    const modifiedParams = {
      ...values,

      page: pagination.page || 0,
      size: pagination.pageSize || 10,
      sortBy: sortBy
        .filter((s) => s.order !== undefined)
        .map((s) => ({
          direction: s.order === "descend" ? "desc" : "asc",
          property: s.field,
        })),
    };
    const deletedKeys = deleteKeysByList(modifiedParams, DELETE_KEYS_LIST);
    return deletedKeys;
  }

  const leaveType = [
    {
      name: "Business Leave",
    },
    {
      name: "Annual Leave",
    },
    {
      name: "Sick Leave",
    },
    {
      name: "Business Leave (without pay)",
    },
  ]
  // const initialValues = useMemo(() => {
  //   return toInitialValues(getLeaveBenefit);
  // }, [getLeaveBenefit]);

  const getEmployLeaveBenefitList = useCallback(
    async (params = {}) => {
      try {
        dispatch(setIsLoading(true));
        const response = await services.getEmployeeLeaveBenefitListPaging({
          ...params,
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: id,
        });
        dispatch(setLeaveBenefitList(response?.data?.page?.content || []));
        setPagination({
          page: params.page + 1,
          current: params.page + 1,
          size: params.size,
          range: [
            params.page * params.size + 1,
            Math.min((params.page + 1) * params.size, response?.data?.page?.totalElements),
          ],
          total: response?.data?.page?.totalElements,
        });
        getDataRemaining({
          companyId: currentCompany,
          employeeId: id,
        })
      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, pagination, id, dispatch]
  );

  const onChange = useCallback(
    (tablePagination, _, tableSorter) => {
      setPagination(tablePagination);
      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];
      setSorter(modifiedSorter);
      const modifiedParams = toParams({
        pagination: {
          page: tablePagination.current - 1,
          pageSize: tablePagination.pageSize,
        },
        sortBy: modifiedSorter,
      });
      // TODO: If sorting or filtering has changed, Change page to 0
      getEmployLeaveBenefitList(modifiedParams);
    },
    [getEmployLeaveBenefitList]
  );

  const onYearChange = useCallback((selectedYear, pageNo, sorter) => {

    const requestBody = toParams({
      year: selectedYear
    });

    getEmployLeaveBenefitList(requestBody);
  }, [getEmployLeaveBenefitList]
  )


  useEffect(() => {
    if (typeof currentCompany !== "object") {
      getEmployLeaveBenefitList({
        page: 0,
        size: 10,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCompany]);


  const getDataRemaining = useCallback(
    async (params) => {
      try {
        dispatch(setIsLoading(true));
        const res = await services.getRemainingLeaveWithIn({
          // companyId: params.currentCompany,
          // employeeId: params.currentEmployee,
          ...params,
          listName: leaveType.map(o => o.name)
        })
        dispatch(setEmpRemainingLeave(res.data))
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [],
  )


  const modifiedLeaveGroupOptions = useMemo(() => {
    let language = i18n.language == "en" ? "En" : "";
    return leaveGroupOptions.map((opt) => ({
      ...opt,
      label: opt?.["leaveTypeName" + language] ?? "",
      value: opt?.leaveTypeId?.id,
    }));
  }, [leaveGroupOptions, i18n.language]);

  const getLeaveGroupOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: id,
        };
        const response = await services.getLeaveGroupIsLeave(values);
        setLeaveGroupOptions(response.data);
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany, dispatch]);

  useEffect(() => {
    getLeaveGroupOptions();
  }, [getLeaveGroupOptions]);

  useEffect(() => {
    getDataRemaining({
      companyId: currentCompany,
      employeeId: id,
    })
  }, [getDataRemaining, currentCompany,
    id,])

  const onDelete = useCallback(
    async (record = {}) => {
      try {

        dispatch(setIsLoading(true));

        const requestBody = {
          companyId: currentCompany,
          employeeId: id,
          leaveBenefitId: record.remainingLeaveId,
          actionId: currentEmployee,
        }
        await services.cancelCustomLeave(requestBody)

        const modifiedParams = toParams({
          year: selectedYear
        });
        message.success(t("common.success"))
        getEmployLeaveBenefitList(modifiedParams);
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  )

  const updateEmploymentInformation
    = useCallback(
      async (value = {}) => {
        try {
          dispatch(setIsLoading(true));
          const modifiedValues = {

            leaveBenefitId: value.leaveTypeDetails.remainingLeaveId,
            totalLeaveDays: value.totalLeaveDays,
            totalLeaveHours: value.totalLeaveHour,
            requestId: generateRandomString(),
            companyId: currentCompany,
            employeeId: id,
            actionId: currentEmployee
          };
          let res = await services.createEmployeeLeaveBenefit(modifiedValues);
          const modifiedParams = toParams({
            year: selectedYear
          });

          if (res?.data?.content?.code != 200) {
            if (res?.data?.content?.details)
              Modal.error({ content: res?.data?.content?.details?.map?.(o => o.value), okText: t("confirm") })

          } else {
            setIsModalOpen(false)
            message.success(t("common.success"))
            getEmployLeaveBenefitList(modifiedParams);
          }

        } catch (error) {
          message.error(t("common.error"))
        } finally {
          dispatch(setIsLoading(false));
        }
      },
      [currentCompany, dispatch]
    );



  const onSubmit = useCallback(

    (values) => {
      const modifiedValues = { ...values, companyId: currentCompany };
      setIsModalOpen(false);
      Modal.confirm({
        title: t("dialog.confirmation.header"),
        content: (
          <span>
            {i18n.language === "en" ? "Are you sure confirm to edit ?" : "คุณแน่ใจหรือไม่ว่าต้องการยืนยันการแก้ไข ?"}
          </span>
        ),
        onOk() {
          updateEmploymentInformation(modifiedValues);
        },
        okText: t("common.confirm").toUpperCase(),
        cancelText: t("common.cancel").toUpperCase(),
      });
      console.log("edit maii", values.leaveBenefitId);

    },
    [currentCompany, updateEmploymentInformation]
  );

  const onCancel = useCallback(() => {
    setIsModalOpen(false);
  }, [])

  const onSearch = useCallback(
    async (params = {}) => {
      setYear(params?.year)
      params.page = 0
      params.size = 10
      try {
        dispatch(setIsLoading(true));
        const response = await services.getEmployeeLeaveBenefitListPaging({
          ...params,
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: id,
          page: 0,
          size: 10
        });

        dispatch(setLeaveBenefitList(response?.data?.page?.content || []));
        setPagination({
          page: params.page + 1,
          current: params.page + 1,
          size: params.size,
          range: [
            params.page * params.size + 1,
            Math.min((params.page + 1) * params.size, response?.data?.page?.totalElements),
          ],
          total: response?.data?.page?.totalElements,
        });
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, pagination, id, dispatch]
  );


  // useEffect(() => {
  //   if (typeof currentCompany !== "object" && params.id) {
  //     getEmployLeaveBenefit(params.id);
  //   }
  // }, [currentCompany, params.id, getEmployLeaveBenefit]);


  const getCardInfo = useCallback(
    () => {

      return (
        <Row gutter={[24]} justify={"center"}>
          <Col  >
            <Row direction='vertical' style={{
              textAlign: "left"
            }}>
              <Avatar
                // width={272}
                size={70}
                alt="logo"
                src={userAvatar()}
              />
              {getInfo.employeeNo && <span style={{
                backgroundColor: "red",
                borderRadius: "20px",
                padding: 5
              }} >{getInfo.employeeNo}</span>}

            </Row>
          </Col>
          <Col>
            <Col>
              <Space size={5}>
                <div>
                  <p href={"item?.href"}>{(getInfo?.name ?? "") + " " + (getInfo?.surName ?? "")}</p>
                </div>
              </Space>
            </Col>
            <Col>
              <Space direction='horizontal' size={5}>
                <span >{t('home.position')} :</span>
                <span >{getInfo.positionName}</span>
              </Space>
            </Col>
          </Col>




        </Row >
      )
    },
    [getInfo],
  )

  const onToggleChange = useCallback(async (status, record) => {
    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (i18n.language === "en"
        ? <span>Are you sure confirm to change status ?</span>
        : <span>คุณยืนยันการเปลี่ยนสถานะใช่หรือไม่ ?</span>
      ),
      okText: t("common.confirm"),
      cancelText: t("common.cancel"),
      onOk: async () => {
        try {
          dispatch(setIsLoading(false));
          await services.manageBenefitStatus({
            statusFlag: status === true ? "ACTIVE" : "INACTIVE",
            companyId: currentCompany,
            employeeId: currentEmployee,
            leaveBenefitId: record?.remainingLeaveId
          })

          const modifiedParams = toParams({
            year: selectedYear
          });
          message.success(t("common.success"))
          getEmployLeaveBenefitList(modifiedParams)

        } catch (error) {
          message.error(t("common.error"))
        } finally {
          dispatch(setIsLoading(false));
        }
      }
    })
  }, [currentCompany, currentEmployee, isLoading])

  return {
    isLoading,
    pagination,
    leaveBenefitList,
    modifiedLeaveGroupOptions,
    getCardInfo,
    currentMyRequest,
    onEdit,
    isModalOpen,
    setIsModalOpen,
    onSubmit,
    onCalculate,
    onDelete,
    onChange,
    onYearChange,
    selectedYear,
    setYear,
    onSearch,
    onToggleChange,
    onCancel
  };

}

export default useEmployeeWorkInLeaveBenefit;
